import {
  getQueryString,
  http,
  throwIfError
} from '@/api/tools.js';

export const api = {
  configuration: async function () {
    const response = await http.get('api/configuration');
    throwIfError(response);
    return response.data;
  },

  getDoc: async function (documentName) {
    const queryString = getQueryString({ documentName });
    const response = await http.getBlob(`getDoc${queryString}`, { options: { nullIfError: true } });
    if (response === null)  
      return null;
    return response.data;
  },

  getLogo2: async function () {
    const response = await http.getBlob('getLogo2', { options: { nullIfError: true } });
  
    if (!response || response.status !== 200 || !response.data) {
      return null;
    }
    if (response.data.type.startsWith('image/')) {
      return response.data;
    }
    return null;
  },  

  getStaticImages: async function () {
    const response = await http.get('getStaticImages');
    throwIfError(response);
    return response.data;
  },

  getImages: async function () {
    const response = await http.get('getImages');
    throwIfError(response);
    return response.data.data;
  },

  cardOwner: async function (card) {
    const queryString = getQueryString({ card });
    const response = await http.get(`api/card-owner${queryString}`);
    throwIfError(response);
    return response.data;
  },

  CardInfo: async function (cardNum) {
    const queryString = getQueryString({ card: cardNum }); // Передача номера карты в параметре card
    const response = await http.get(`api/cards${queryString}`);
    throwIfError(response);
    return response.data;
  },

  registerBeginPurchase: async function (data) {
    const response = await http.post('api/register-begin-purchase', data);
    throwIfError(response);
    return response.data;
  },

  getCatalog: async function (posId, visitDate) {
    const queryString = getQueryString({ posId, visitDate });
    const response = await http.get(`api/catalog${queryString}`);
    throwIfError(response);
    return response.data;
  },

  emulatePayment: async function (saleId, amount) {
    const queryString = getQueryString({ cardNum: saleId, amount });
    const response = await http.post(`api/register-payment${queryString}`);
    throwIfError(response);
    return response.data;
  },

  getOrder: async function (orderId) {
    const queryString = getQueryString({ orderId });
    const response = await http.get(`api/get-order${queryString}`);
    throwIfError(response);
    return response.data;
  }
};
  
